import type { FaireProductEntity } from "../../entity_types/product";

export const p_us6bdcbhmj: FaireProductEntity = {
  token: "p_us6bdcbhmj",
  type: "product",
  name: 'Palo Santo Smudge Bombs w/ Burner 2.5" x 2.5"',
  brandToken: "b_89kf2nlsjr",
  brandName: "Designs by Deekay Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/6533d39dbfd3765b62342b8fc0dc4fb92fb393cad93eb61c6916822e1ceb19fb.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.08,
  description:
    'Palo Santo Smudge Bombs w/ Burner\n \n PRODUCT SPECS\n • Dimensions: 2.5" x 2.5" x 2.5"\n • Pack Format: 5 smudge bombs with burner included\n • Material: Blend of herbs, fragrance, and incense\n • Fragrance: Palo Santo\n • Use: Light bomb and place in included burner\n • Format: All-in-one cleansing set\n \n RETAIL PERFORMANCE\n • Gift-ready set format increases perceived value\n • Included burner supports easy merchandising and upsell\n • Palo Santo profile is a strong seller in cleansing categories\n • Strong countertop and seasonal gifting potential\n • Easy cross-merchandise with sprays, oils, and sage bundles',
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:49.233Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
